import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'LOGGING__SET_SUPPORT_USERS':
            return core.setSupportUsers(state, action.supportUsers);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/SupportUsers/reducer.js